module.exports = __webpack_public_path__ + "chinagen_logo.png?13af232638fee95f59b3f12f56112898";